import { Component, Input, OnInit } from "@angular/core";
import { ActividadesService } from "src/app/services/actividades.service";
import { AuthService } from "src/app/services/auth.service";
import { ComponentDataService } from "src/app/services/component-data.service";
import { CursosService } from "src/app/services/cursos.service";
import {
  AlertController,
  ModalController,
  NavController,
  Platform,
} from "@ionic/angular";
import * as internal from "stream";
import * as jQuery from "jquery";
import { Observable } from "rxjs";
import { FormControl } from "@angular/forms";
import { debounceTime } from "rxjs/operators";
import { Console } from "console";
import { StorageService } from "src/app/services/storage.service";
import * as moment from "moment";
import { environment } from "src/environments/environment";
import { ProductosService } from "src/app/services/productos.service";
import { GlobalsService } from "src/app/api/globals.service";

@Component({
  selector: "app-crear-actividad-actividades-curso",
  templateUrl: "./crear-actividad-actividades-curso.component.html",
  styleUrls: ["./crear-actividad-actividades-curso.component.scss"],
})
export class CrearActividadActividadesCursoComponent implements OnInit {
  @Input() public curso: any;
  @Input() public opcion: any;
  @Input() public ACTIVIDADES_CONFIG: any = [];
  @Input() public ACTIVIDAD_CURSO_CONFIG: any = [];
  @Input() public DATA_CURSO: any = [];
  //[componente]="componente"
  @Input() public componente = 0;
  @Input() callbackFunctionComponent: (
    args1: number,
    args2: number,
    args3: number,
    args4: string,
    args5: number
  ) => void;
  @Input() student = false;
  @Input() public isEstudentRegister: any;
  ID: number;
  AUTH_KEY: string;
  ACTIVIDADES: any;
  //ACTIVIDADES_CONFIG:any = [];
  ACTIVIDAD_CURSO: any = [];
  // ACTIVIDAD_CURSO_CONFIG:any = [];
  LIBROS_USERS: any = [];
  CURSOS_USERS: any = [];
  CONTINUE: number;
  TIND_Active = -1;
  Load = false;
  idSearch: number;
  isSearch: boolean;
  searchTipo: number;
  public searchControlUsers: FormControl;
  isDevice: boolean;
  imgUrl = "";

  fecha = {
    start: "2024-01-19 00:00",
    end: "2024-01-20 23:59",
  };
  botonRango = false;
  fechaString = "2024-01-19 00:00 - 2024-01-20 23:59";
  suscripcion = false;
  dataLoaded: boolean = false;
  isIos = false;
  rutaRef = "";
  constructor(
    private authService: AuthService,
    public actividadesService: ActividadesService,
    private cursosService: CursosService,
    public alertController: AlertController,
    public globalsService: GlobalsService,
    private platform: Platform,
    private service: ProductosService,
    public navCtrl: NavController
  ) {
    this.isDevice = false;
    this.searchControlUsers = new FormControl();
    this.imgUrl = environment.host + "/uploads/assets/imagenes/productos/";
    this.isIos = globalsService.plataforma == "ios" ? true : false;
    this.rutaRef = environment.urlFront + "ecommerce";
    platform.ready().then(() => {
      if (
        this.platform.is("android") ||
        this.platform.is("ios") ||
        this.platform.is("cordova")
      ) {
        this.isDevice = true;
      } else {
        this.isDevice = false;
      }
    });
  }

  ngOnInit() {
    console.log("CursoCurso:", this.curso);
    this.authService.userData$.subscribe((res: any) => {
      let auth_key = "";
      let rsponse: any = res;
      if (rsponse.auth_key != undefined) {
        auth_key = rsponse.auth_key;
        this.ID = rsponse.id;
        this.AUTH_KEY = auth_key;
        this.getlicense();
        console.log("COMPONENTE: ", this.componente);
        this.actividadesService
          .getAllActividadesCursos(auth_key, this.curso.id)
          .subscribe((response) => {
            if (response !== undefined) this.ACTIVIDADES = response;
            this.CONTINUE = 0;
            this.Load = true;
            if (this.ACTIVIDADES) {
              this.ACTIVIDADES.forEach((element, i) => {
                let ids: any = [];
                let id_libro_nodata = element.data.id;
                if (element.actividades.data != undefined) {
                  element.actividades.activities.forEach((element, i) => {
                    ids.push({
                      id_actividad: element[0].data.id_actividad,
                      id_tipo: element[0].data.id_tipo,
                    });
                  });
                  let disponible = 1;
                  let t_individual = 0;
                  let t_individualArray = [];
                  let calificable = 1;
                  let o_aleatorio = 1;
                  let id_libro = element.data.id;
                  let tipo = 1;
                  let filtered;
                  filtered = this.arrayExistIndex(
                    id_libro,
                    this.ACTIVIDADES_CONFIG
                  );
                  if (!filtered)
                    this.ACTIVIDADES_CONFIG.push({
                      actividades: ids,
                      disponible: disponible,
                      t_individual: t_individual,
                      t_individualArray: t_individualArray,
                      calificable: calificable,
                      o_aleatorio: o_aleatorio,
                      id_libro: id_libro,
                      tipo: tipo,
                    });
                } else {
                  let filtered;
                  filtered = this.arrayExistIndex(
                    id_libro_nodata,
                    this.ACTIVIDADES_CONFIG
                  );
                  if (!filtered)
                    this.ACTIVIDADES_CONFIG.push({
                      id_libro: id_libro_nodata,
                      tipo: 0,
                    });
                }
                this.CONTINUE = this.ACTIVIDADES.length;
              });
              this.dataLoaded = true;
            }

            // getActividadCurso
            this.cursosService
              .getActividadCurso(this.ID, this.curso.id, this.AUTH_KEY)
              .subscribe(async (res: any) => {
                if (!res.error) {
                  //mapea los que son actividades del curso y las que son de los libos
                  res.map((element) => {
                    element.data.map((element2) => {
                      if (element2.id_libro == null) {
                        this.ACTIVIDAD_CURSO.push(element);
                        this.dataLoaded = true;
                      } else {
                        this.ACTIVIDADES.forEach((element3) => {
                          if (element3.data.id == element2.id_libro) {
                            element3.actividades.push(element);
                          }
                        });
                      }
                    });
                  });
                }
              });
            this.imgUrl =
              environment.host + "/uploads/assets/imagenes/productos/";
          });
      }
      this.idSearch = 0;
      this.isSearch = false;
      this.searchTipo = 0;
      this.searchControlUsers.valueChanges
        .pipe(debounceTime(700))
        .subscribe((search) => {
          // this.searching = false;
          let searchC: any = this.searchControlUsers;
          console.log("this.searchControlUsers: ", searchC);
          this.setFilteredItems(search);
        });
    });
  }

  getlicense() {
    this.service
      .getLicense(this.AUTH_KEY, this.ID)
      .subscribe((response: any) => {
        console.log("🚀 ~ this.service.getLicense ~ response:", response);
        if (response.suscripcion) {
          this.suscripcion = response.suscripcion;
        }
      });
  }

  arrayExistIndex(valor, array) {
    let filtered = false;
    array.forEach((element, i, array) => {
      // console.log('FILTER: ',element.id_libro);
      // console.log('FILTER valor: ',valor);
      if (element.id_libro == valor) {
        filtered = true;
      }
      if (i == array.length - 1) {
      }
    });
    return filtered;
  }
  arrayExistIndexCurso(valor, array) {
    let filtered = false;
    array.forEach((element, i, array) => {
      // console.log('FILTER: ',element.id_libro);
      // console.log('FILTER valor: ',valor);
      if (element.id == valor) {
        filtered = true;
      }
      if (i == array.length - 1) {
      }
    });
    return filtered;
  }

  validarFecha(start, end) {
    const ahora = moment();
    return start == "0" || end == "0" || start == null || end == null
      ? true
      : ahora.isBetween(start, end);
  }

  getConfActividad(id_libro) {
    let id_act = 0;
    this.ACTIVIDADES_CONFIG.forEach((element) => {
      if (element.id_libro == id_libro) {
        id_act = element.disponible;
      }
    });
    return id_act;
  }
  getConfActividadCurso(id) {
    let id_act = 0;
    // this.ACTIVIDAD_CURSO_CONFIG.forEach((element) => {
    //   if (element.id == id) {
    //     id_act = element.disponible;
    //   }
    // });
    return id_act;
  }
  getConfCalificable(id_libro) {
    let id_cal = 0;
    this.ACTIVIDADES_CONFIG.forEach((element) => {
      if (element.id_libro == id_libro) {
        id_cal = element.calificable;
      }
    });
    return id_cal;
  }

  getConfCalificableCurso(id) {
    let id_cal = 0;
    this.ACTIVIDAD_CURSO_CONFIG.forEach((element) => {
      if (element.id == id) {
        id_cal = element.calificable;
      }
    });
    return id_cal;
  }
  getConfOAleatorio(id_libro) {
    let id_oal = 0;
    this.ACTIVIDADES_CONFIG.forEach((element) => {
      if (element.id_libro == id_libro) {
        id_oal = element.o_aleatorio;
      }
    });
    //
    return id_oal;
  }
  getConfOCursoAleatorio(id) {
    let id_oal = 0;
    this.ACTIVIDAD_CURSO_CONFIG.forEach((element) => {
      if (element.id == id) {
        id_oal = element.o_aleatorio;
      }
    });
    return id_oal;
  }

  actividadDisponible(event) {
    //return;
    let estado = 0;
    this.ACTIVIDADES_CONFIG.forEach((element) => {
      if (element.id_libro == event.target.dataset.id_libro) {
        estado = element.disponible = parseInt(event.detail.value);
      }
    });
  }

  actividadCursoDisponible(event) {
    //return;
    let estado = 0;
    this.ACTIVIDAD_CURSO_CONFIG.forEach((element) => {
      if (element.id == event.target.dataset.curso) {
        estado = element.disponible = parseInt(event.detail.value);
      }
    });
  }

  actividadCalificable(event) {
    let estado = 0;
    this.ACTIVIDADES_CONFIG.forEach((element) => {
      if (element.id_libro == event.target.dataset.id_libro) {
        estado = element.calificable = parseInt(event.detail.value);
      }
    });
  }
  actividadCursoCalificable(event) {
    let estado = 0;
    this.ACTIVIDAD_CURSO_CONFIG.forEach((element) => {
      if (element.id == event.target.dataset.curso) {
        estado = element.calificable = parseInt(event.detail.value);
      }
    });
  }
  actividadOAleatorio(event) {
    let estado = 0;
    this.ACTIVIDADES_CONFIG.forEach((element) => {
      if (element.id_libro == event.target.dataset.id_libro) {
        estado = element.o_aleatorio = parseInt(event.detail.value);
      }
    });
  }
  actividadOCursoAleatorio(event) {
    let estado = 0;
    this.ACTIVIDAD_CURSO_CONFIG.forEach((element) => {
      if (element.id == event.target.dataset.curso) {
        estado = element.o_aleatorio = parseInt(event.detail.value);
      }
    });
  }

  actividadDisponibleEstado(id_lib) {
    //ACTIVIDADES_CONFIG[i].disponible
    let estado = 0;
    this.ACTIVIDADES_CONFIG.forEach((element) => {
      if (element.id_libro === id_lib) {
        estado = parseInt(element.disponible);
      }
    });
    return estado;
  }

  deleteActivities(event) {
    this.presentAlertConfirm(event);
  }
  async presentAlertConfirm(event) {
    const alert = await this.alertController.create({
      cssClass: "rm-book-alert",
      header: "¿Desa eliminar este libro?",
      message: "",
      buttons: [
        {
          text: "Cancelar",
          role: "cancel",
          cssClass: "secondary",
          handler: (blah) => {},
        },
        {
          text: "Continuar",
          handler: () => {
            let id_libro = event.target.dataset.id_libro;
            this.cursosService
              .rmCursoLibro(this.ID, this.curso.id, id_libro, this.AUTH_KEY)
              .subscribe((res: any) => {
                // console.log(res);
                if (!res.error) {
                  this.ACTIVIDADES.forEach((element, i, array) => {
                    if (element.data.id == id_libro) {
                      this.ACTIVIDADES.splice(i, 1);
                    }
                  });
                }
              });
          },
        },
      ],
    });

    await alert.present();
  }

  expandTr(index) {
    //alert("expand-btn-"+index);
    if (
      jQuery(".expand-btn-" + index)
        .attr("class")
        .includes("initial")
    ) {
      jQuery(".expand-btn-" + index + "")
        .removeClass("initial")
        .addClass("unset");

      jQuery(".tr-content-" + (index + 1)).animate(
        {
          opacity: 1.0,
          left: "-=50",
          height: "toggle",
        },
        200,
        function () {
          // Animation complete.
        }
      );
    } else {
      jQuery(".expand-btn-" + index)
        .removeClass("unset")
        .addClass("initial");
      jQuery(".tr-content-" + (index + 1)).animate(
        {
          opacity: 1.0,
          left: "+=50",
          height: "toggle",
        },
        200,
        function () {
          // Animation complete.
        }
      );
    }
  }

  setBtnInd(id) {
    let color = "light";
    this.ACTIVIDAD_CURSO_CONFIG.forEach((element) => {
      if (element.id == id && element.t_individual == 1) {
        color = "secondary";
      } else {
        color = "light";
      }
    });
    return color;
  }
  setActiveBtnCursoInd(id, flag) {
    if (this.TIND_Active == flag) {
      this.TIND_Active = -1;
      return;
    } else {
      this.TIND_Active = flag;
    }
    this.searchTipo = 2;

    this.ACTIVIDAD_CURSO_CONFIG.forEach((element) => {
      if (element.id == id) {
        if (element.t_individual == 0) {
          element.t_individual = 0;
          // this.isSearch =true;
          this.getStudents(id, "tr-config-curso-" + id, 2);
        } else {
          element.t_individual = 0;
        }
      } else {
        // element.t_individual = 0;
      }
    });
  }

  setActiveBtnInd(id, flag) {
    if (this.TIND_Active == flag) {
      this.TIND_Active = -1;
      return;
    } else {
      this.TIND_Active = flag;
    }
    // if(this.TIND_Active >= 0){
    //   this.TIND_Active = -1;
    // }else
    // this.TIND_Active = flag;

    this.ACTIVIDADES_CONFIG.forEach((element) => {
      if (element.id_libro == id) {
        if (element.t_individual == 0) {
          element.t_individual = 0;

          this.getStudents(id, "tr-config-libro-" + id, 1);
        } else {
          element.t_individual = 0;
        }
      } else {
        // element.t_individual = 0;
      }
    });
  }

  setFilteredItems(search) {
    let id = this.idSearch;
    let tipo = this.searchTipo;

    console.log("setFilteredItems : ", tipo);
    this.isSearch = true;
    if (tipo == 1) {
      this.getStudents(id, "tr-config-libro-" + id, 1, search);
      console.log("setFilteredItems 1: ", tipo);
    }
    if (tipo == 2) {
      this.getStudents(id, "tr-config-curso-" + id, 2, search);
      console.log("setFilteredItems 2: ", tipo);
    }
  }

  getStudents(id, element, tipo, params = "") {
    // getStudents
    this.cursosService
      .getStudents(this.ID, this.AUTH_KEY, params)
      .subscribe((response) => {
        var node = document.getElementById(element);

        var x = node.getElementsByTagName("ion-card-content");
        let btnNode: any = document.getElementById(id);
        let list: any = response;
        this.isSearch = false;
        let divs = "<ion-grid><ion-row>";
        let checked = "checked";
        let active = "";
        let clase = "";
        let claseChkbx = "";
        let claseChkbxG = "";
        let id_array = "";
        list.users.forEach((element) => {
          checked = "";
          active = "";
          if (tipo == 1) {
            clase = "chkbx-libro" + id;
            this.ACTIVIDADES_CONFIG.forEach((element1) => {
              if (element1.id_libro == id) {
                element1.t_individualArray.forEach((element2) => {
                  if (element2 == element.id) {
                    checked = "checked";
                    active = "active";
                  }
                });
              }
            });
            claseChkbx = ".chkbx-libro" + id;
            claseChkbxG = "chkbx-libro";
          } else {
            clase = "chkbx-curso" + id;
            this.ACTIVIDAD_CURSO_CONFIG.forEach((element1) => {
              if (element1.id == id) {
                element1.t_individualArray.forEach((element2) => {
                  console.log("XXXXXXX element2: ", element2);
                  if (element2 == element.id) {
                    checked = "checked";
                    active = "active";
                  }
                });
              }
            });
            claseChkbx = ".chkbx-curso" + id;
            claseChkbxG = "chkbx-curso";
          }
          divs +=
            '<ion-col class="product-items compact"><div>' +
            '<ion-card class="card-product" style="box-shadow:none">' +
            '<ion-card-content style="margin-bottom: 1px;">' +
            '<div style="width: 125px;margin: auto;height: 155px;padding: 10px;border: 1px solid var(--ion-color-secondary);border-radius:8px;">' +
            '<div class="img-chk ' +
            active +
            ' "><label for="user-' +
            element.id +
            "-" +
            id +
            ' "><ion-img src="assets/imagenes/check-mark.png"></ion-img></label></div>' +
            '<label class="a-link" for="user-' +
            element.id +
            "-" +
            id +
            ' ">' +
            '<ion-img class="img-products" src="assets/imagenes/user1.png"style="width: 75px;text-align: center;margin: auto;"></ion-img>' +
            "</label>" +
            "<div>" +
            '<h2 text-capitalize style="padding: 5px 0px;">' +
            '<label for="user-' +
            element.id +
            "-" +
            id +
            ' " class="a-link" style+"font-size: 14px;" > ' +
            element.nombre_apellido +
            " </label>" +
            '<input class="' +
            clase +
            " " +
            claseChkbxG +
            '" data-id="' +
            element.id +
            '" id="user-' +
            element.id +
            "-" +
            id +
            ' " ' +
            checked +
            ' data-libro="' +
            id +
            '" type="checkbox" name="users' +
            id +
            '[]" value="' +
            element.id +
            '" />' +
            "</h2>" +
            "</div>" +
            "</div>" +
            "</ion-card-content>" +
            //
            "</ion-card>" +
            "</div></ion-col>";
        });
        divs += "</ion-row></ion-grid>";
        x[0].innerHTML = divs;
        //xx[0].innerHTML = ("");
        if (tipo == 1) {
          console.log("claseChkbxG tipo 1: ", claseChkbxG);

          this.listenersChckBox1(claseChkbxG);
        } else {
          console.log("claseChkbxG tipo 2: ", claseChkbxG);
          this.listenersChckBox2(claseChkbxG);
        }
      });
  }

  removeDuplicates(originalArray, prop) {
    var newArray = [];
    var lookupObject = {};

    for (var i in originalArray) {
      lookupObject[originalArray[i][prop]] = originalArray[i];
    }

    for (i in lookupObject) {
      newArray.push(lookupObject[i]);
    }
    return newArray;
  }

  listenersChckBox1(claseChkbxG) {
    let _this = this;
    jQuery("." + claseChkbxG).on("click", function () {
      let ID_LIBRO = jQuery(this).data("libro");
      // });
      _this.ACTIVIDADES_CONFIG.forEach((ACFelement) => {
        if (ACFelement.id_libro == ID_LIBRO) {
          ACFelement.t_individualArray.forEach((AINDelement) => {
            _this.LIBROS_USERS.push({
              id_libro: ID_LIBRO,
              id_user: AINDelement,
            });
          });
        }
      });

      let checkbox = jQuery(this);
      if (_this.LIBROS_USERS.length > 0) {
        let add = true;
        let index = 0;
        _this.LIBROS_USERS.forEach((element, i, array) => {
          if (element.id_libro == jQuery(this).data("libro")) {
            if (element.id_user == jQuery(this).data("id")) {
              add = false;
              index = i;
            }
          }
        });
        let filtered = [];
        if (!add && !jQuery(this).is(":checked")) {
          //_this.LIBROS_USERS.splice(index,1);
          console.log(
            "DELETE LIBROS_USERS RM: " + jQuery(this).data("id") + " - " + index
          );
          let id_user = jQuery(this).data("id");
          let filtered = _this.LIBROS_USERS.filter(function (value, idx, arr) {
            return value.id_user != id_user;
          });
          console.log("filtered: ", filtered);
          _this.LIBROS_USERS = null;
          _this.LIBROS_USERS = [];
          filtered.forEach((filteredI) => {
            console.log("filteredI: ", filteredI);
            _this.LIBROS_USERS.push(filteredI);
          });

          // _this.LIBROS_USERS = filtered;
          jQuery(this)
            .closest(".card-content-md")
            .find(".img-chk")
            .removeClass("active");
        } else if (add) {
          jQuery(this)
            .closest(".card-content-md")
            .find(".img-chk")
            .addClass("active");

          _this.LIBROS_USERS.push({
            id_libro: jQuery(this).data("libro"),
            id_user: jQuery(this).data("id"),
          });
        }
        console.log(
          "LIBROS_USERS: " + index + "-" + jQuery(this).is(":checked"),
          _this.LIBROS_USERS
        );
      } else {
        _this.LIBROS_USERS.push({
          id_libro: ID_LIBRO,
          id_user: jQuery(this).data("id"),
        });
        jQuery(this)
          .closest(".card-content-md")
          .find(".img-chk")
          .addClass("active");
        console.log("LIBROS_USERS: ", _this.LIBROS_USERS);
      }
    });
  }
  listenersChckBox2(claseChkbxG) {
    let _this = this;
    jQuery("." + claseChkbxG).on("click", function () {
      let ID_CURSO = jQuery(this).data("libro");

      _this.ACTIVIDAD_CURSO_CONFIG.forEach((ACFelement) => {
        if (ACFelement.id == ID_CURSO) {
          ACFelement.t_individualArray.forEach((AINDelement) => {
            _this.CURSOS_USERS.push({
              id_curso: ID_CURSO,
              id_user: AINDelement,
            });
          });
        }
      });

      let checkbox = jQuery(this);
      if (_this.CURSOS_USERS.length > 0) {
        let add = true;
        let index = 0;
        _this.CURSOS_USERS.forEach((element, i, array) => {
          if (element.id_curso == jQuery(this).data("libro")) {
            if (element.id_user == jQuery(this).data("id")) {
              add = false;
              index = i;
            }
          }
        });
        let filtered = [];
        if (!add && !jQuery(this).is(":checked")) {
          //_this.LIBROS_USERS.splice(index,1);
          console.log(
            "DELETE CURSOS_USERS RM: " + jQuery(this).data("id") + " - " + index
          );
          let id_user = jQuery(this).data("id");
          let filtered = _this.CURSOS_USERS.filter(function (value, idx, arr) {
            return value.id_user != id_user;
          });
          console.log("filtered: ", filtered);
          _this.CURSOS_USERS = null;
          _this.CURSOS_USERS = [];
          filtered.forEach((filteredI) => {
            console.log("filteredI: ", filteredI);
            _this.CURSOS_USERS.push(filteredI);
          });
          jQuery(this)
            .closest(".card-content-md")
            .find(".img-chk")
            .removeClass("active");
        } else if (add) {
          _this.CURSOS_USERS.push({
            id_curso: jQuery(this).data("libro"),
            id_user: jQuery(this).data("id"),
          });
          jQuery(this)
            .closest(".card-content-md")
            .find(".img-chk")
            .addClass("active");
        }
        console.log(
          "CURSOS_USERS: " + index + "-" + jQuery(this).is(":checked"),
          _this.CURSOS_USERS
        );
      } else {
        _this.CURSOS_USERS.push({
          id_curso: ID_CURSO,
          id_user: jQuery(this).data("id"),
        });
        jQuery(this)
          .closest(".card-content-md")
          .find(".img-chk")
          .addClass("active");
        console.log("CURSOS_USERS: ", _this.CURSOS_USERS);
      }
    });
  }

  onSearchInput(index, tipo) {
    this.idSearch = index;
    this.searchTipo = tipo;
    console.log("searchTipo: ", this.searchTipo);
  }
  findValueInArray(value, arr) {
    let result = false;
    for (let i = 0; i < arr.length; i++) {
      let name = arr[i];
      if (name == value) {
        result = true;
        break;
      }
    }
    return result;
  }

  selectUsers(id) {
    //Confirmar btn
    this.ACTIVIDADES_CONFIG.forEach((element1) => {
      let array = [];
      if (element1.id_libro == id) array = [];

      this.LIBROS_USERS.forEach((element2, i, arr) => {
        if (element2.id_libro == element1.id_libro && element1.id_libro == id) {
          if (i == 0) {
          }
          array.push(element2.id_user);
          if (
            !this.findValueInArray(element2.id_user, element1.t_individualArray)
          ) {
          }
        }
      });
      if (element1.id_libro == id) element1.t_individualArray = array;
    });
    console.log(
      "UPDATE this.ACTIVIDADES_CONFIG: " + id,
      this.ACTIVIDADES_CONFIG
    );
  }

  selectUsersCurso(id) {
    console.log("this.CURSOS_USERS: ", this.CURSOS_USERS.length);
    this.ACTIVIDAD_CURSO_CONFIG.forEach((element1) => {
      let array = [];
      if (element1.idCurso == id) array = [];

      this.CURSOS_USERS.forEach((element2, i, arr) => {
        if (element2.id_curso == element1.id && element1.id == id) {
          if (i == 0) {
          }
          array.push(element2.id_user);
          if (
            !this.findValueInArray(element2.id_user, element1.t_individualArray)
          ) {
          }
        }
      });
      if (element1.id == id) {
        element1.t_individualArray = array;
        console.log(
          "UPDATE ACTIVIDAD_CURSO_CONFIG: ",
          this.ACTIVIDAD_CURSO_CONFIG
        );
      }
    });
  }

  realizarActividad(id, tipo, nombre_actividad, posicion, item) {
    console.log("item: ", item);
    console.log(
      "id_libro: " +
        id +
        ", tipo: " +
        tipo +
        ", nombre de laactividad: " +
        nombre_actividad +
        ", posición: " +
        posicion
    );
    let option = this.student ? 102 : 100;
    this.callbackFunctionComponent(
      option,
      id,
      tipo,
      nombre_actividad,
      posicion
    );
  }

  navigateSuscripcion() {
    this.navCtrl.navigateRoot("/ecommerce");
  }
}
